export function isOptionValue<const Value extends string>(
  options: readonly { value: Value }[],
  value: string | null | undefined,
): value is Value {
  return options.some((option) => option.value === value);
}
